module.exports = __webpack_public_path__ + "img/sc-3.d8e2986c.png";